/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'goal-fields.goal-followers.add-followers-title': 'Tilføj følgere',
  'goal-fields.goal-followers.title': 'Følgere',
  'goal-fields.goal-links.add-parent-goal-title': 'Tilføj et overordnet mål',
  'goal-fields.goal-links.edit-parent-goal-title': 'Rediger overordnet mål',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Fjern tilknytning af overordnet mål',
  'goal-fields.goal-metrics.automatic-metric-title': 'Fra delmål',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Fjern',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Indstillinger',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Vis mere',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Opdater værdi',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Start:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Mål:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'Status udfyldes automatisk via {compass}. Denne målmåling kan kun redigeres i {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Gå til målsiden for at ændre dette felt',
  'goal-fields.goal-metrics.no-metrics-title': 'Ingen måling',
  'goal-fields.goal-metrics.open-in-new-window-label': 'Åbn i nyt vindue',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'fremskridt gjort',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Ingen delmål med målinger tilknyttet',
  'goal-fields.goal-metrics.title': 'Status',
  'goal-fields.goal-owner.title': 'Ejer',
  'goal-fields.goal-start-date.add-start-date-title': 'Tilføj startdato',
  'goal-fields.goal-start-date.cancel-button': 'Gem',
  'goal-fields.goal-start-date.creation-date': 'Dette mål blev oprettet {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Rediger startdato for mål',
  'goal-fields.goal-start-date.enter-start-date-title': 'Angiv startdato',
  'goal-fields.goal-start-date.open-calendar-label': 'Åbn kalender',
  'goal-fields.goal-start-date.title': 'Startdato',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'Igangværende',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Flere statusser',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'Hvad er den aktuelle status?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    "Vil du øve dig i mål og nøgleresultater? <link>Se, hvordan man bruger mål til OKR'er</link>",
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Hjælpelink',
  'goal-fields.goal-status.archived': 'Arkiveret',
  'goal-fields.goal-status.at-risk': 'I farezonen',
  'goal-fields.goal-status.cancelled': 'Annulleret',
  'goal-fields.goal-status.completed': 'Afsluttet 🎉',
  'goal-fields.goal-status.off-track': 'På vildspor',
  'goal-fields.goal-status.on-track': 'På ret kurs',
  'goal-fields.goal-status.paused': 'Sat på pause',
  'goal-fields.goal-status.pending': 'Afventer',
  'goal-fields.goal-status.title': 'Status',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Tilføj delmål',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Fjern tilknytning af undermål',
  'goal-fields.goal-tags.add-tags-title': 'Tilføj tags',
  'goal-fields.goal-tags.title': 'Tags',
  'goal-fields.goal-target-date.picker-placeholder': 'Afventer',
  'goal-fields.goal-target-date.title': 'Måldato',
  'goal-fields.goal-type.goal': 'Mål',
  'goal-fields.goal-type.key-result': 'Nøgleresultat',
  'goal-fields.goal-type.objective': 'Formål',
  'goal-fields.goal-type.title': 'Type',
  'goal-fields.parent-goal.title': 'Overordnet mål',
  'goal-fields.sub-goals.title': 'Delmål',
  'goal-fields.teams.add-teams-title': 'Tilføj teams',
  'goal-fields.teams.follow-team': 'Følg team',
  'goal-fields.teams.remove-team': 'Fjern team',
  'goal-fields.teams.search-team-placeholder': 'Søg efter team',
  'goal-fields.teams.show-more': 'Vis mere',
  'goal-fields.teams.title': 'Teams',
  'goal-fields.teams.verified-team-label': 'Bekræftet team',
  'goal-fields.teams.view-profile': 'Vis profil',
  'goal-fields.use-goal-flags.generic-error-description': 'Der gik noget galt. Prøv igen om et par minutter.',
  'goal-fields.use-goal-flags.generic-error-title': 'Noget gik galt',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Målejeren kunne ikke ændres',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'Tagget kunne ikke tilføjes',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Tagget kunne ikke oprettes',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'Det angivne tagnavn er for langt. Angiv et tagnavn med højst 255 tegn.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'Tagget kunne ikke oprettes',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Tagget kunne ikke fjernes',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title':
    'Der opstod en fejl under tilføjelse af teamet. Prøv igen.',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title':
    'Der opstod en fejl under fjernelse af teamet. Prøv igen.',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Kunne ikke ændre overordnet mål',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Startdatoen kunne ikke ændres',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Måldatoen kunne ikke ændres',
  'townsquare.goal-fields.tag': 'Fjern tag',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {Brugt {usageCount,number} sted} other {Brugt {usageCount,number} steder}}',
};
